module.exports = __webpack_public_path__ + "media/flags/na-c98ec4d4.svg";